import whenDomReady from "when-dom-ready";
import renderFromPreloadedJSON from "~/common/renderFromPreloadedJSON";
import CompatibleWithPage from ".";

whenDomReady(async () => {
  if (document.querySelector('[data-hypernova-key="CompatibleWithPage"]')) {
    renderFromPreloadedJSON(CompatibleWithPage, "CompatibleWithPage");
  }
});
